import { FormikProps } from "formik";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import * as yup from "yup";
import { FormatHelper } from "../../../assets/utils/helpers/formatHelper";
import { CommunityDevelopmentDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";
import { useState } from "react";
import { OtherCategoryId } from "./types";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface CommunityDevelopmentLookupProps {
    responses: LookupDto[] | undefined;
    tags?: LookupDto[] | undefined
    category?: LookupDto[] | undefined
}
interface CommunityDevelopmentFormProps {
    data: CommunityDevelopmentDto | undefined;
    show: boolean;
    lookups: CommunityDevelopmentLookupProps | undefined;
    onHide: () => void;
    onEdit?: () => void;
    onSave: (values: CommunityDevelopmentDto) => DrawerFormSaveResult;
}

const validationSchema = yup.object().shape({
    otherText: yup.string().when("categoryId", ([categoryId], schema) => {
        if (categoryId === OtherCategoryId) {
            return yup.string()
                .required("Other text is required.")
                .test(
                    "not-empty",
                    "Other text is required.",
                    (value) => value !== Constants.emptyGuid
                );
        }
        else {
            return yup.string().notRequired();
        }
        return schema;
    }),
});

export const CommunityDevelopmentForm = (props: CommunityDevelopmentFormProps) => {
    const [isFavorite, setIsFavorite] = useState(props.data?.isFavorite ?? false);
    const submittedDate: string | null = props.data?.submittedDate ? FormatHelper.formatUtcLocalDate(props.data?.submittedDate) : Constants.emptyString;
    const isLoading = props.show && !props.data;
    const onSubmit = (data: CommunityDevelopmentDto) => {
        data.tagId = data.tagId != "" && data.tagId != Constants.emptyGuid ? data.tagId : undefined;
        data.responseTypeId = data.responseTypeId == "" || data.responseTypeId == Constants.emptyGuid ? undefined : data.responseTypeId;
        if (data.categoryId?.toLowerCase() !== OtherCategoryId) {
            data.otherText = undefined;
        }
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };
    return (
        <>
            <Drawer.Form
                className="w-30"
                show={props.show}
                backdrop={true}
                placement="end"
                scroll={true}
                onHide={props.onHide}
                title={"Edit Community Development"}
                initialValues={props.data ?? {}}
                validationSchema={validationSchema}
                on_Submit={onSubmit}
                enableReinitialize
            >
                {(formikProps: FormikProps<CommunityDevelopmentDto>) => (
                    <>
                        <Form.Hidden name="message" value={props.data?.message} />
                        <Form.Hidden name="submittedDate" value={props.data?.submittedDate} />

                        <Form.PanelSection iconClassName="bi bi-chat-left-text" title="1. Submission">
                            <DisplayData text="Message" importedData={props.data?.message} />
                            <DisplayData text="Submitted date" importedData={submittedDate} />
                        </Form.PanelSection>

                        <Form.PanelSection
                            iconClassName="bi bi-ui-checks"
                            title="2. Review Details"
                            style={{ marginTop: 16 }}
                        >
                            <Form.Dropdown
                                name="categoryId"
                                label="Category"
                                isLoading={isLoading}
                                blankOption={{
                                    key: Constants.emptyGuid,
                                    display: "Select Category",
                                    value: Constants.emptyGuid,
                                }}
                                options={LookupDto.mapToOptions(props?.lookups?.category)}
                            />
                            {formikProps.values?.categoryId !== undefined && formikProps.values?.categoryId !== null && formikProps.values?.categoryId?.toLowerCase() === OtherCategoryId
                                && <Form.Text
                                    name="otherText"
                                    label="Other"
                                    placeholder="Other"
                                    isLoading={isLoading}
                                />}
                            <Form.Dropdown
                                name="tagId"
                                label="Tag Type"
                                isLoading={isLoading}
                                blankOption={{
                                    key: Constants.emptyGuid,
                                    display: "Select Tag Type",
                                    value: Constants.emptyGuid,
                                }}
                                options={LookupDto.mapToOptions(props?.lookups?.tags)}
                            />

                            <Form.Dropdown
                                name="responseTypeId"
                                label="Response"
                                isLoading={isLoading}
                                blankOption={{
                                    key: Constants.emptyGuid,
                                    display: "Select Respose",
                                    value: Constants.emptyGuid,
                                }}
                                options={LookupDto.mapToOptions(props?.lookups?.responses)}
                            />
                            <Form.Checkbox
                                name="isFavorite"
                                label="Favorite"
                                key="isFavorite"
                                checked={isFavorite}
                                onChange={(e: any) => setIsFavorite(e.target.checked)}
                            />
                        </Form.PanelSection>
                    </>
                )}
            </Drawer.Form>
        </>
    );
};
